var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_709_5915)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3293 21.27L29.0593 27L27.5693 28.49L21.8393 22.76C20.7693 23.53 19.4793 24 18.0693 24C14.4793 24 11.5693 21.09 11.5693 17.5C11.5693 13.91 14.4793 11 18.0693 11C21.6593 11 24.5693 13.91 24.5693 17.5C24.5693 18.91 24.0993 20.2 23.3293 21.27ZM18.0693 13C15.5793 13 13.5693 15.01 13.5693 17.5C13.5693 19.99 15.5793 22 18.0693 22C20.5593 22 22.5693 19.99 22.5693 17.5C22.5693 15.01 20.5593 13 18.0693 13Z",
    fill: "#7BD755"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_709_5915"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.569336,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchicon);
export default __webpack_public_path__ + "static/media/searchicon.0cecbd0c1134ce6af0593bbfd358b374.svg";
export { ForwardRef as ReactComponent };